import { Component, OnInit, Input } from '@angular/core';
import { PageService } from '../page.service'

@Component({
  selector: 'app-tag-page',
  templateUrl: './tag-page.component.html',
  styleUrls: ['./tag-page.component.css']
})
export class TagPageComponent implements OnInit {
  @Input() start: number

  constructor(private pgs: PageService) { }

  ngOnInit() {
  }

  get label() {
    let pgLen = this.pgs.pageLength
    let totalLen = this.pgs.recordsLength
    let end = this.start + pgLen
    if (end > totalLen)
      end = totalLen
    return `${this.start + 1}-${end}`
  }

  switch() {
    this.pgs.currentStart = this.start
  }

  get isSelected() {
    return this.pgs.currentStart == this.start
  }
}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/tag-page/tag-page.component.ts